import { render, staticRenderFns } from "./teacher-main.vue?vue&type=template&id=c564c646"
import script from "./teacher-main.vue?vue&type=script&lang=js"
export * from "./teacher-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports